import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import AppContext from "../../context/app/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { Divider } from "antd";
import PageHeader from "../../components/general/layout/page-header";
import SearchFilterCard from "../../components/general/filter-card";
import ContactUsContext from "../../context/contactus/context";
import ContactUsTable from "../../components/contactus/contactus-table";
import ContactUsContextProvider from "../../context/contactus/provider";

interface IProps {
  children?: React.ReactNode;
}

const ContactUs: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);

  const [search, setSearch] = useState<string | undefined>(undefined);
  const { actions, loading, query } = useContext(ContactUsContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("contact_us")}
        subTitle={t("contact_us")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
        ]}
      />
      <SearchFilterCard
        formId="contact-us-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() =>
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          })
        }
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      />
      

      <ContactUsTable />
    </div>
  );
};

const ContactUsPage = () => {
  return (
    <ContactUsContextProvider>
      <ContactUs />
    </ContactUsContextProvider>
  );
};

export default ContactUsPage;
